module.exports = __webpack_public_path__ + "static/media/How to add and update File notes.cd527d60.png";